import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Establishments = () => {
  const [establishments, setEstablishments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEstablishments = () => {
    const token = localStorage.getItem('token');
    fetch('/api/super-admin/establishments', {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    })
      .then((r) => r.json())
      .then((data) => setEstablishments(Array.isArray(data) ? data : []))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchEstablishments();
  }, []);

  const toggleEstablishment = async (id) => {
    if (!window.confirm('Changer le statut de ce lycée ?')) return;
    const token = localStorage.getItem('token');
    await fetch(`/api/super-admin/establishments/${id}/toggle`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    fetchEstablishments();
  };

  return (
    <div className="p-4 md:p-6">
      {/* En-tête : on passe en flex-col sur mobile pour éviter que le bouton écrase le titre */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-[#2C3E50]">🏫 Lycées</h1>
          <p className="text-gray-600 mt-1 text-sm md:text-base">Gérez tous les établissements.</p>
        </div>
        <Link
          to="/super-admin/establishments/new"
          className="w-full sm:w-auto text-center bg-[#F39C12] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#E67E22] transition"
        >
          ➕ Créer un lycée
        </Link>
      </div>

      {loading ? (
        <div className="text-center py-20 text-gray-500">Chargement...</div>
      ) : establishments.length === 0 ? (
        <div className="text-center py-20 text-gray-500">Aucun lycée enregistré.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {establishments.map((est) => (
            <div
              key={est.id}
              className="bg-white rounded-2xl p-5 md:p-6 shadow-md border border-gray-100 hover:shadow-lg transition flex flex-col"
            >
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg md:text-xl font-bold text-[#2C3E50] break-words pr-2">{est.name}</h3>
                <span
                  className={`text-xs px-3 py-1 rounded-full font-semibold whitespace-nowrap ${
                    est.is_active
                      ? 'bg-green-100 text-green-700'
                      : 'bg-red-100 text-red-700'
                  }`}
                >
                  {est.is_active ? 'Actif' : 'Inactif'}
                </span>
              </div>

              <div className="flex-1">
                {est.email && (
                  <div className="text-sm text-gray-600 mb-1 truncate">📧 {est.email}</div>
                )}
                {est.phone && (
                  <div className="text-sm text-gray-600 mb-3">📞 {est.phone}</div>
                )}

                <div className="grid grid-cols-3 gap-2 my-4 pt-4 border-t border-gray-100">
                  <div className="text-center">
                    <div className="text-lg font-bold text-[#2C3E50]">{est.students_count ?? 0}</div>
                    <div className="text-xs text-gray-500">Élèves</div>
                  </div>
                  <div className="text-center">
                    <div className="text-lg font-bold text-[#2C3E50]">{est.teachers_count ?? 0}</div>
                    <div className="text-xs text-gray-500">Profs</div>
                  </div>
                  <div className="text-center">
                    <div className="text-lg font-bold text-[#2C3E50]">{est.admins_count ?? 0}</div>
                    <div className="text-xs text-gray-500">Admins</div>
                  </div>
                </div>
              </div>

              <button
                onClick={() => toggleEstablishment(est.id)}
                className={`w-full py-3 md:py-2 rounded-lg text-sm font-semibold transition mt-2 ${
                  est.is_active
                    ? 'bg-red-50 text-red-600 hover:bg-red-100'
                    : 'bg-green-50 text-green-600 hover:bg-green-100'
                }`}
              >
                {est.is_active ? '🔒 Désactiver' : '🔓 Activer'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Establishments;